import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import type {
  AdvertisingReport,
  GetAdvertisingReportInput,
} from '@borradh-workspace/api-client/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const fetchAdvertisingReport = (
  input: GetAdvertisingReportInput,
  signal?: AbortSignal
) =>
  apiClient.get<AdvertisingReport>(
    `admin-terminal/advertising?${new URLSearchParams(
      Object.entries(input)
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => [key, String(value)])
    )}`,
    { signal }
  );

export const advertisingReportQueryOptions = (
  input: GetAdvertisingReportInput
) =>
  queryOptions({
    queryKey: queryKeys.adminTerminal.advertisingReport(input),
    queryFn: ({ signal }) => fetchAdvertisingReport(input, signal),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });

export const useAdvertisingReport = (input: GetAdvertisingReportInput) =>
  useQuery(advertisingReportQueryOptions(input));
